import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core";
import React from "react";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0f3593",
    },
  },
});

const ThemeProvider: React.FC<{}> = ({ children }) => {
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
};

export default ThemeProvider;
